import { Link as MuiLink, Alert, Box, Button, Checkbox, DialogContent, FormControlLabel, FormHelperText, IconButton, Stack, TextField, Typography } from "@mui/material"
import { Link, useNavigate } from "react-router-dom"
import { RoutePaths } from "../routes"
import { Controller, useForm } from "react-hook-form"
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import { forwardRef, useEffect, useState } from "react";
import CheckIcon from '@mui/icons-material/Check';
import { IMaskInput } from 'react-imask';
import DOMPurify from 'dompurify';
import { usePostFeedBack } from "../queries/useFeedback";


const YearOfBirthInput = forwardRef(function YearOfBirthInput(props, ref) {
    const { onChange, ...other } = props
    return (
        <IMaskInput
            {...other}
            inputRef={ref}
            mask="YYYY"
            onAccept={(value) => {
                onChange(value);
            }}
            definitions={{
                'Y': /[0-9]/
            }}
        />
    )
})

const isValidEmail = (val) => {
    // eslint-disable-next-line no-useless-escape
    let regEmail = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (!regEmail.test(val)) {
        return 'Введите корректный Email';
    }
}

const isValidYearBirth = (val) => {
    if (val < 1900 || val > 2025) {
        return 'Введите корректный год рождения'
    }
}

const FeedbackPage = () => {

    const [state, setState] = useState()
    const navigate = useNavigate()
    const { control, handleSubmit, watch, reset, setValue } = useForm({
        defaultValues: {
            fio: '',
            yearBirth: '',
            email: '',
            question: '',
            consent: false,
        },
        mode: 'onSubmit'
    })

    const { mutate: postFeedBack, isSuccess, isLoading, error } = usePostFeedBack()

    const onSubmit = async (data) => {
        // Санитизируем данные перед отправкой
        const sanitizedData = {
            fio: DOMPurify.sanitize(data.fio),
            yearBirth: DOMPurify.sanitize(data.yearBirth),
            email: DOMPurify.sanitize(data.email),
            question: DOMPurify.sanitize(data.question),
        }
        console.log("save", sanitizedData)
        postFeedBack(sanitizedData)
    }

    useEffect(() => {
        if (isSuccess) {
            setState('success')
            reset()
        }
    }, [isSuccess, reset])

    useEffect(() => {
        if (error) {
            setState('error')
        }
    }, [error])

    return (
        <>
            <IconButton disableRipple onClick={() => navigate(RoutePaths.SUPPORT)} sx={{
                color: 'blue.400'
            }} >
                <ArrowBackIosIcon />
            </IconButton>

            <Typography variant="h1">Форма обратной связи</Typography>

            <form method='POST' onSubmit={handleSubmit(onSubmit)}>
                <Stack spacing={3}>

                    {isLoading &&
                        <Alert severity="info">
                            Отправка
                        </Alert>
                    }

                    {state === 'success' &&
                        <Alert icon={<CheckIcon fontSize="inherit" />} severity="success">
                            Ваш вопрос успешно отправлен
                        </Alert>
                    }

                    {state === 'error' &&
                        <Alert severity="error">
                            При отправке вопроса возникла ошибка. Вопрос не отправлен.
                        </Alert>
                    }

                    <Controller
                        name='fio'
                        control={control}
                        rules={{ required: "Поле обязательно для заполнения" }}
                        render={({ field, fieldState: { error } }) => {
                            return (
                                <TextField {...field}
                                    label='ФИО'
                                    autoFocus
                                    margin="dense"
                                    variant="outlined"
                                    error={Boolean(error)}
                                    helperText={error && error.message}
                                />
                            )
                        }}
                    />

                    <Controller
                        name='yearBirth'
                        control={control}
                        rules={{
                            required: "Поле обязательно для заполнения",
                            validate: isValidYearBirth,
                        }}
                        render={({ field, fieldState: { error } }) => {
                            return (
                                <TextField {...field}
                                    label='Год рождения'
                                    margin="dense"
                                    InputProps={{
                                        inputComponent: YearOfBirthInput,
                                        inputMode: 'numeric', pattern: '[0-9]*' // для мобильных устр.
                                    }}
                                    type="number"
                                    variant="outlined"
                                    error={Boolean(error)}
                                    helperText={error && error.message}
                                />
                            )
                        }}
                    />

                    <Controller
                        name='email'
                        control={control}
                        rules={{
                            required: 'Поле обязательно для заполнения',
                            validate: isValidEmail,
                        }}
                        render={({ field, fieldState: { error } }) => {
                            return (
                                <TextField {...field}
                                    label='Email'
                                    margin="dense"
                                    variant="outlined"
                                    error={Boolean(error)}
                                    helperText={error && error.message}
                                />
                            )
                        }}
                    />

                    <Controller
                        name='question'
                        control={control}
                        rules={{ required: "Поле обязательно для заполнения" }}
                        render={({ field, fieldState: { error } }) => {
                            return (
                                <TextField {...field}
                                    label='Опишите ваш вопрос'
                                    multiline
                                    minRows={4}
                                    margin="dense"
                                    variant="outlined"
                                    error={Boolean(error)}
                                    helperText={error && error.message}
                                />
                            )
                        }}
                    />

                    <Controller
                        name="consent"
                        control={control}
                        rules={{ required: "Поле обязательно для заполнения" }}
                        render={({ field, fieldState: { error } }) => {
                            return (
                                <>
                                    <Stack>
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    color="primary"
                                                    checked={field.value}
                                                    onChange={(e) => field.onChange(e.target.checked)}
                                                />
                                            }
                                            label={<>
                                                <MuiLink href='/attach/Cогласие на обработку персональных данных.docx' download title='Cогласие на обработку персональных данных'>
                                                    Согласие
                                                </MuiLink>
                                                &nbsp;на&nbsp;
                                                <MuiLink component={Link} to={RoutePaths.POLICY} target="_blank" title='Политика обработки персональных данных'>
                                                    обработку персональных данных
                                                </MuiLink>
                                                .
                                            </>}
                                        />
                                        {error?.message && <FormHelperText error>{error.message}</FormHelperText>}
                                    </Stack>
                                </>
                            )
                        }}
                    />

                    <Box>
                        <Button type="submit"
                            variant="outlined"
                            onClick={() => setState(null)}
                        >Отправить</Button>
                    </Box>
                </Stack>
            </form>
        </>
    )
}

export default FeedbackPage
